export const firebaseConfig = {
    apiKey: "AIzaSyB7nXyEbtyqgI7L9koxbOwsclyYiuSwYH8",
    authDomain: "pokpak-6cd7b.firebaseapp.com",
    databaseURL: "https://pokpak-6cd7b.firebaseio.com",
    projectId: "pokpak-6cd7b",
    storageBucket: "pokpak-6cd7b.appspot.com",
    messagingSenderId: "444035011447"
}


// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/environments/firebase.config.ts